// removed by extract-text-webpack-plugin
module.exports = {"container":"container__2Q_YC"};


//////////////////
// WEBPACK FOOTER
// ./routes/coc/style.css
// module id = 3pAe
// module chunks = 10